import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 12 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6 3C4.346 3 3 4.346 3 6s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3Zm0 5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2Zm0-8a6 6 0 0 0-6 6c0 2.42.843 3.095 5.383 9.677a.75.75 0 0 0 1.234 0C11.157 9.095 12 8.42 12 6a6 6 0 0 0-6-6Zm0 14.81C1.647 8.515 1 8.015 1 6c0-1.336.52-2.591 1.464-3.536A4.967 4.967 0 0 1 6 1c1.336 0 2.591.52 3.536 1.464A4.967 4.967 0 0 1 11 6c0 2.015-.647 2.515-5 8.81Z" }, null, -1)
  ]))]))
}
export default { render: render }